import React, { useState,useContext } from 'react';
import { Grid,TextField,Button,CardMedia,CardContent,Typography,List,ListItem,ListItemButton,Box} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import Dashboard from '../Dashboard/Dashboard';
import ShopingContext from '../context/ShopingContext';
import Snackbar from '@mui/material/Snackbar';
import CircleIcon from '@mui/icons-material/FiberManualRecord';

const Shop = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const { category,product,selectedCategoryID, setSelectedCategoryID,addToCart ,setSnackbarOpen,snackbarOpen } = useContext(ShopingContext); // ✅ Access products from context
  const handleCategorySelect = (selectedCategoryName) => {
    const selectedCategory = category.find(cat => cat.Category === selectedCategoryName);
    setSelectedCategoryID(selectedCategory ? selectedCategory.CategoryID : "-1"); // Update CategoryID
  };
  const filteredProducts = product.filter(product =>
    product.ProdName.toLowerCase().includes(searchQuery.toLowerCase())
  );
  // Add this style constant outside your component
const categoryButtonStyles = {
  borderRadius: 2,
  px: 2,
  py: 1,
  transition: 'all 0.2s ease',
  '&:hover': {
    bgcolor: 'action.hover',
    transform: 'translateX(4px)'
  },
  '&.Mui-selected': {
    bgcolor: 'primary.light',
    color: 'primary.contrastText',
    '&:hover': {
      bgcolor: 'primary.main'
    }
  }
};

  return (
    <Dashboard>
      <Snackbar
  open={snackbarOpen}
  autoHideDuration={3000}
  onClose={() => setSnackbarOpen(false)}
  message="Product added to cart successfully"
  anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
 
/>
    <Grid container spacing={3}>
      {/* Left Sidebar */}
      <Grid item xs={12} md={3} sx={{ pr: 3, borderRight: 1, borderColor: 'divider'}}>
      <TextField
  fullWidth
  variant="outlined"
  placeholder="Search products..."
  value={searchQuery}
  onChange={(e) => setSearchQuery(e.target.value)}
  InputProps={{
    startAdornment: (
      <SearchIcon sx={{ 
        mr: 1.5,
        ml: 0.5,
        color: 'text.secondary',
        fontSize: '1.25rem',
        transition: 'color 0.2s ease',
        '&:hover': {
          color: 'primary.main'
        }
      }}
      />
    ),
    sx: {
      borderRadius: 3,
      bgcolor: 'background.paper',
      boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.05)',
      transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      border: '1px solid',
      borderColor: 'divider',
      '&:hover': {
        boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
        borderColor: 'primary.light'
      },
      '&.Mui-focused': {
        boxShadow: '0px 4px 12px rgba(63, 81, 181, 0.2)',
        borderColor: 'primary.main',
        bgcolor: 'background.default'
      }
    }
  }}
  sx={{ 
    mb: 4,
    '& .MuiOutlinedInput-input': {
      py: 1.5,
      fontSize: '0.95rem'
    }
  }}
  inputProps={{
    style: {
      paddingLeft: '8px',
      letterSpacing: '0.02rem'
    }
  }}
  // Add placeholder styling
  FormHelperTextProps={{
    sx: {
      '&::placeholder': {
        fontStyle: 'italic',
        color: 'text.disabled',
        fontSize: '0.9rem'
      }
    }
  }}
/>

  <Typography variant="h6" sx={{ 
    fontWeight: 700,
    color: 'text.primary',
    mb: 2,
    pb: 1,
    borderBottom: 2,
    borderColor: 'primary.main',
    letterSpacing: 0.5
  }}>
    Product Categories
  </Typography>

  <List dense sx={{ 
    bgcolor: 'background.paper',
    borderRadius: 2,
    p: 1,
    // boxShadow: 1
  }}>
    <ListItem disablePadding sx={{ mb: 0.5 }}>
      <ListItemButton
        selected={selectedCategoryID === "-1"}
        onClick={() => setSelectedCategoryID("-1")}
        sx={categoryButtonStyles}
      >
        <Box component="span" sx={{ fontWeight: 600 }}>
          All Categories
        </Box>
      </ListItemButton>
    </ListItem>

    {category.map(cat => (
      <ListItem key={cat.CategoryID} disablePadding sx={{ mb: 0.5 }}>
        <ListItemButton
          selected={cat.CategoryID === selectedCategoryID}
          onClick={() => handleCategorySelect(cat.Category)}
          sx={categoryButtonStyles}
        >
          <Box component="span" sx={{ 
            flexGrow: 1,
            fontWeight: cat.CategoryID === selectedCategoryID ? 600 : 500
          }}>
            {cat.Category}
          </Box>
          {cat.CategoryID === selectedCategoryID && (
            <CircleIcon sx={{ 
              fontSize: 8,
              color: 'primary.light',
              ml: 1
            }}/>
          )}
        </ListItemButton>
      </ListItem>
    ))}
  </List>
</Grid>





      {/* Product Grid */}
      <Grid item xs={12} md={9}>
  <Grid container spacing={2}>
    {filteredProducts.map((product) => (


<Grid item key={product.id} xs={12} sm={6} md={4}>
<Box sx={{
  p: 2,
  borderRadius: "12px",
  backgroundColor: "#fff",
  boxShadow: '0 4px 24px rgba(0,0,0,0.08)',
  position: "relative",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
  overflow: 'hidden',
  '&:hover': { 
    transform: "translateY(-4px)",
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
    '& .product-image': {
      transform: 'scale(1.05)'
    }
  },
}}>
  {/* Discount Badge */}
  {product.ProductPercentage && (
    <Box sx={{
      position: 'absolute',
      top: 12,
      left: 12,
      backgroundColor: '#2FA8EF',
      color: 'white',
      px: 1.5,
      py: 0.5,
      borderRadius: '4px',
      fontSize: '0.75rem',
      fontWeight: 700,
      zIndex: 2
    }}>
      {product.ProductPercentage}% OFF
    </Box>
  )}

  {/* Product Image */}
  <Box  
    sx={{ 
      width: "100%", 
      height: "200px", 
      position: 'relative',
      overflow: "hidden", 
      borderRadius: "8px",
      cursor: "pointer",
      '&:hover .image-overlay': {
        opacity: 1
      }
    }}
  >
    <img 
      src={product.ProdImage} 
      alt={product.ProdName} 
      className="product-image"
      style={{ 
        width: "100%", 
        height: "100%", 
        objectFit: "contain",
        transition: 'transform 0.3s ease' 
      }} 
    />
    <Box className="image-overlay" sx={{
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(180deg, rgba(54,121,90,0) 60%, rgba(54,121,90,0.15) 100%)',
      opacity: 0,
      transition: 'opacity 0.3s ease'
    }} />
  </Box>

  {/* Product Info */}
  <Box sx={{ pt: 2 }}>
    <Typography 
      variant="h6" 
      sx={{
        fontSize: "0.95rem",
        fontWeight: 600,
        color: '#333',
        lineHeight: 1.3,
        mb: 1,
        cursor: "pointer",
        '&:hover': { color: '#2FA8EF' }
      }}
      
    >
      {product.ProdName}
    </Typography>

    {/* Price Section */}
    <Box sx={{ 
      display: 'flex', 
      alignItems: 'center',
      gap: 1.5,
      mt: 1
    }}>
      <Typography sx={{ 
        fontSize: "1rem",
        fontWeight: 700,
        color: '#1E7CB7'
      }}>
        NPR {product.ProdRetailPrice}
      </Typography>
      {product.ProdMrpPrice && (
        <Typography sx={{
          fontSize: "0.875rem",
          color: "text.secondary",
          textDecoration: "line-through"
        }}>
          NPR {product.ProdMrpPrice}
        </Typography>
      )}
    </Box>

    {/* Action Buttons */}
    <Box sx={{ 
      display: 'flex', 
      gap: 1, 
      mt: 2,
      opacity: 1,
      transition: 'opacity 0.3s ease'
    }}>
      <Button 
        variant="contained" 
        size="small"
        onClick={() => addToCart(product)}
        sx={{
          backgroundColor: '#2FA8EF',
          color: 'white',
          borderRadius: '6px',
          px: 2,
          py: 1,
          fontSize: '0.75rem',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: 'text.secondary'
          }
        }}
      >
        Add to Cart
      </Button>
      {/* <Button 
        variant="outlined" 
        size="small"
        onClick={() => handleProductClick(product)}
        sx={{
          borderColor: '#ddd',
          color: '#555',
          borderRadius: '6px',
          px: 2,
          py: 1,
          fontSize: '0.75rem',
          textTransform: 'none',
          '&:hover': {
            borderColor: '#2FA8EF',
            color: '#2FA8EF'
          }
        }}
      >
        Quick View
      </Button> */}
    </Box>
  </Box>
</Box>
</Grid>
    ))}
  </Grid>
</Grid>





      
    </Grid>
    </Dashboard>
  );
};

export default Shop;